import { render, staticRenderFns } from "./FlashSale.vue?vue&type=template&id=27dc4158&scoped=true&"
import script from "./FlashSale.vue?vue&type=script&lang=js&"
export * from "./FlashSale.vue?vue&type=script&lang=js&"
import style0 from "./FlashSale.vue?vue&type=style&index=0&id=27dc4158&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dc4158",
  null
  
)

export default component.exports